import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import Form, { ButtonItem, ButtonOptions, GroupItem, Item, Label, RequiredRule, CheckBox } from "devextreme-react/form";
import Request from "../../components/Request/Request";
//import * as AppActions from '../../../actions/AppActions';
import { ToastType } from "../../constants/Constants";
import { showToast, parseDate, hasRole } from "../../utils/Utils";
import * as AppActions from '../../actions/AppActions';
const EmeklilikKosulDetay = (props) => {

    const dispatch = useDispatch();

    const [data, setData] = useState();
    const [isEdit, setIsEdit] = useState(false);
    const [belgeTuruDataSource, setBelgeTuruDataSource] = useState([]);
    const [cinsiyetDataSource, setCinsiyetDataSource] = useState([]);
    const [engelDurumuDataSource, setEngelDurumuDataSource] = useState([]);
    const [sigortaTuruDataSource, setSigortaTuruDataSource] = useState([]);
    const [kosulTipiDataSource, setKosulTipiDataSource] = useState([]);
    const [calismaTipiDataSource, setCalismaTipiDataSource] = useState([]);

    useEffect(() => {
        setStaticList();
        getData();

        setTimeout(function () { //Start the timer
            setIsEdit(true);
        }.bind(this), 1000)
    }, [])

    function setStaticList() {
        const belgeTuruRequest = new Request("/emeklilik-app/api/enum-tanim/getList/BelgeTuru", "GET");
        belgeTuruRequest.run()
            .then(response => {
                if (response.data && response.data.data) {
                    setBelgeTuruDataSource(response.data.data);
                }
            });

        const cinsiyetRequest = new Request("/emeklilik-app/api/enum-tanim/getList/Cinsiyet", "GET");
        cinsiyetRequest.run()
            .then(response => {
                if (response.data && response.data.data) {
                    setCinsiyetDataSource(response.data.data);
                }
            });
        const engelDurumuRequest = new Request("/emeklilik-app/api/enum-tanim/getList/EngelDurumu", "GET");
        engelDurumuRequest.run()
            .then(response => {
                if (response.data && response.data.data) {
                    setEngelDurumuDataSource(response.data.data);
                }
            });

        const sigortaTuruRequest = new Request("/emeklilik-app/api/enum-tanim/getList/SigortaTuru", "GET");
        sigortaTuruRequest.run()
            .then(response => {
                if (response.data && response.data.data) {
                    setSigortaTuruDataSource(response.data.data);
                }
            });

        const kosulTipiRequest = new Request("/emeklilik-app/api/enum-tanim/getList/KosulTipi", "GET");
        kosulTipiRequest.run()
            .then(response => {
                if (response.data && response.data.data) {
                    setKosulTipiDataSource(response.data.data);
                }
            });

        const calismaTipiRequest = new Request("/emeklilik-app/api/enum-tanim/getList/CalismaTipi", "GET");
        calismaTipiRequest.run()
            .then(response => {
                if (response.data && response.data.data) {
                    setCalismaTipiDataSource(response.data.data);
                }
            });
    }

    const getData = () => {

        let id = -1;
        if (props.data && props.data.id) {
            id = props.data.id;
        } else if (props.data) {
            setData(props.data);
            return;
        } else {
            setData({ belgeTuru: "A4", cinsiyet: "TUMU", engelDurumu: "YOK", sigortaTuru: "NORMAL", calismaTipi: "NORMAL", kosulTipi: "NORMAL" });
            return;
        }
        dispatch(AppActions.setLoading(true, "Kayıt Yükleniyor.."));
        const request = new Request("/emeklilik-app/api/emeklilik-kosul/getKayit/" + id, "GET");
        return request.run()
            .then(response => {
                setData(response.data.data);
                dispatch(AppActions.setLoading(false, ""));
            });
    }
    function kaydet(e) {

        let eksikBilgi = false;
        e.validationGroup.validators.map((a) => {
            if (a.validate().status !== "valid") {
                eksikBilgi = true;
            }
        }
        );
        if (eksikBilgi) {
            showToast('Zorunlu alanları kontrol ediniz', ToastType.ERROR, 500);
            return;
        }

        let formData = data;

        let method = "POST"
        let url = "/emeklilik-app/api/emeklilik-kosul/save";


        const request = new Request(url, method, formData);
        dispatch(AppActions.setLoading(true, "Kayıt işlemi yapılıyor.."));
        return request.run()
            .then(response => {
                dispatch(AppActions.setLoading(false, ""));
                if (response.data && response.data.data) {
                    props.hide();
                }
            });


    }


    return (
        <div >
            <Form formData={data} id="form" labelLocation={"left"} className="option" >

                <GroupItem cssClass="first-group" caption={"Kayıt Bilgileri"} colCount={2}>

                    <Item disabled={false} dataField={'adi'} editorType={'dxTextBox'}
                        editorOptions={{}}>
                        <RequiredRule message="Adı bilgisi gerekli" />
                        <Label text='Adı' />
                    </Item>
                    <Item disabled={false} dataField={'kanunBilgi'} editorType={'dxTextBox'}
                        editorOptions={{}}>
                        <RequiredRule message="Kanun bilgisi gerekli" />
                        <Label text='Kanun No' />
                    </Item>
                </GroupItem>

                <GroupItem cssClass="first-group" caption={"Ön Koşul Bilgileri"} colCount={2}>
                    <Item disabled={false} dataField={'belgeTuru'} editorType={'dxSelectBox'}
                        editorOptions={{
                            dataSource: belgeTuruDataSource,
                            valueExpr: "id",
                            displayExpr: "name",
                            placeholder: "Select a value..."
                        }}>
                        <RequiredRule message="Belge Türü bilgisi gerekli" />
                        <Label text='Belge Türü' />
                    </Item>

                    <Item disabled={false} dataField={'cinsiyet'} editorType={'dxSelectBox'}
                        editorOptions={{
                            dataSource: cinsiyetDataSource,
                            valueExpr: "id",
                            displayExpr: "name",
                            placeholder: "Select a value..."
                        }}>
                        <RequiredRule message="Cinsiyet bilgisi gerekli" />
                        <Label text='Cinsiyet' />
                    </Item>

                    <Item disabled={false} dataField={'sigortaTuru'} editorType={'dxSelectBox'}
                        editorOptions={{
                            dataSource: sigortaTuruDataSource,
                            valueExpr: "id",
                            displayExpr: "name",
                            placeholder: "Select a value..."
                        }}>
                        <RequiredRule message="SigortaTuru bilgisi gerekli" />
                        <Label text='SigortaTuru' />
                    </Item>

                    <Item disabled={false} dataField={'calismaTipi'} editorType={'dxSelectBox'}
                        editorOptions={{
                            dataSource: calismaTipiDataSource,
                            valueExpr: "id",
                            displayExpr: "name",
                            placeholder: "Select a value..."
                        }}>
                        <RequiredRule message="Çalışma Tipi bilgisi gerekli" />
                        <Label text='Çalışma Tipi' />
                    </Item>

                    <Item disabled={false} dataField={'kosulTipi'} editorType={'dxSelectBox'}
                        editorOptions={{
                            dataSource: kosulTipiDataSource,
                            valueExpr: "id",
                            displayExpr: "name",
                            placeholder: "Select a value..."
                        }}>
                        <RequiredRule message="Koşul Tipi bilgisi gerekli" />
                        <Label text='Koşul Tipi' />
                    </Item>

                    <Item disabled={false} />

                    <Item disabled={false} dataField={'iseGirisBasTarihi'} editorType={'dxDateBox'}
                        editorOptions={{
                            displayFormat: "yyyy-MM-dd"
                        }}>
                        <Label text='İşe Giriş Tarihi Baş.' />
                    </Item>
                    <Item disabled={false} dataField={'iseGirisBitTarihi'} editorType={'dxDateBox'}
                        editorOptions={{
                            displayFormat: "yyyy-MM-dd"
                        }}>
                        <Label text='İşe Giriş Tarihi Bit.' />
                    </Item>
                    <Item dataField={'sigortalilikSure'} editorType={'dxNumberBox'}
                        editorOptions={{
                            stylingMode: 'outlined',
                            min: 1,
                            max: 50
                        }}>
                        <Label text={'Sigortalılık Süre(Yıl)-'} />
                    </Item>

                    <Item dataField={'sigortalilikGun'} editorType={'dxNumberBox'}
                        editorOptions={{
                            stylingMode: 'outlined',
                            min: 0,
                            max: 15000
                        }}>
                        <Label text={'Sigortalılık Gün-'} />
                    </Item>

                    <Item dataField={'sigortalilikGunYasUzaklik'} editorType={'dxNumberBox'}
                        editorOptions={{
                            stylingMode: 'outlined',
                            min: 1,
                            max: 50
                        }}>
                        <Label text={'Yaş yada güne olan uzaklık(Yıl)-'} />
                    </Item>

                    <Item></Item>
                    <Item disabled={false} dataField={'gununOlustuguBasTarihi'} editorType={'dxDateBox'}
                        editorOptions={{
                            displayFormat: "yyyy-MM-dd"
                        }}>
                        <Label text='Günün oluştuğu Tarihi Baş.' />
                    </Item>
                    <Item disabled={false} dataField={'gununOlustuguBitTarihi'} editorType={'dxDateBox'}
                        editorOptions={{
                            displayFormat: "yyyy-MM-dd"
                        }}>
                        <Label text='Günün oluştuğu Tarihi Bit.' />
                    </Item>
                </GroupItem>


                <GroupItem cssClass="first-group" caption={"Engel-Rapor Bilgileri"} colCount={2}>

                    <Item disabled={false} dataField={'engelDurumu'} editorType={'dxSelectBox'}
                        editorOptions={{
                            dataSource: engelDurumuDataSource,
                            valueExpr: "id",
                            displayExpr: "name",
                            placeholder: "Select a value..."
                        }}>
                        <RequiredRule message="EngelDurumu bilgisi gerekli" />
                        <Label text='EngelDurumu' />
                    </Item>
                    <Item disabled={false} />
                    <Item dataField={'raporOranBaslangic'} editorType={'dxNumberBox'}
                        editorOptions={{
                            stylingMode: 'outlined',
                            min: 40,
                            max: 99
                        }}>
                        <Label text={'Rapor Oran baş.'} />
                    </Item>

                    <Item dataField={'raporOranBitis'} editorType={'dxNumberBox'}
                        editorOptions={{
                            stylingMode: 'outlined',
                            min: 40,
                            max: 100
                        }}>
                        <Label text={'Rapor Oran bit.'} />
                    </Item>

                </GroupItem>

                <GroupItem cssClass="first-group" caption={"Emeklilik Şart Bilgileri"} colCount={2}>
                    <Item dataField={'emeklilikSartSigSure'} editorType={'dxNumberBox'}
                        editorOptions={{
                            stylingMode: 'outlined',
                            min: 0,
                            max: 50
                        }}>
                        <Label text={'Sigortalılık Süre(Yıl)'} />
                    </Item>
                    <Item dataField={'emeklilikSartSigSureAy'} editorType={'dxNumberBox'}
                        editorOptions={{
                            stylingMode: 'outlined',
                            min: 0,
                            max: 12
                        }}>
                        <Label text={'Sigortalılık Süre(Ay)'} />
                    </Item>
                    <Item dataField={'emeklilikSartSigGun'} editorType={'dxNumberBox'}
                        editorOptions={{
                            stylingMode: 'outlined',
                            min: 0,
                            max: 15000
                        }}>
                        <Label text={'Sigortalılık Gün'} />
                    </Item>
                    <Item dataField={'emeklilikSartSigYas'} editorType={'dxNumberBox'}
                        editorOptions={{
                            stylingMode: 'outlined',
                            min: 0,
                            max: 75
                        }}>
                        <Label text={'Emeklilik Yaşı'} />
                    </Item>
                </GroupItem>














                <ButtonItem>
                    <ButtonOptions
                        onClick={(e) => { kaydet(e); }}
                        width={'100%'}
                        type={'success'}
                        useSubmitBehavior={true}>
                        <span className="dx-button-text">
                            {'Kaydet'
                            }
                        </span>
                    </ButtonOptions>
                </ButtonItem>

            </Form>


        </div>
    )
}

export default EmeklilikKosulDetay;
